import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../utils/api';
import '../../styles/auth.css';

const ForgotPassword = () => {
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    
    if (!username.trim()) {
      toast.error('Please enter your username');
      return;
    }

    setLoading(true);

    try {
      const res = await api.post('/api/auth/forgot-password', { username });
      
      setSubmitted(true);
      toast.success(res.data.message);
    } catch (err) {
      const message = err.response?.data?.message || 'An error occurred. Please try again.';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="auth-page page-narrow">
        <div className="auth-card">
          <div className="form-container">
            <h1>Check Your Email</h1>
            <div className="auth-success-message">
              <p>If a user with the username "{username}" exists, we've sent a password reset link to the email address associated with the account.</p>
              <p>The link will expire in 15 minutes for security reasons.</p>
              <p>Please check your email and follow the instructions to reset your password.</p>
            </div>
            <div className="auth-links">
              <p><Link to="/login">Back to Login</Link></p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="form-container">
          <h1>Forgot Password</h1>
          <p className="auth-description">
            Enter your username and we'll send you a link to reset your password.
          </p>
          <form onSubmit={onSubmit}>
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                name="username"
                className="form-control"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your username"
                required
                disabled={loading}
              />
            </div>
            <button 
              type="submit" 
              className="btn btn-primary btn-block"
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>
          <div className="auth-links">
            <p>Remember your password? <Link to="/login">Login</Link></p>
            <p>Don't have an account? <Link to="/register">Register</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;